import { createSlice } from "@reduxjs/toolkit";

// Dashboard type definition
export interface Dashboard {
  id: string;
  name: string;
  layouts: any;
  cardLayout: any;
  visibleComponents: string[];
  visibleCards: string[];
}

export interface DashboardConfigState {
  dashboards: Dashboard[];
}

const initialState: DashboardConfigState = {
  dashboards: [],
};

const DashboardConfigSlice = createSlice({
  name: "dashboardConfig",
  initialState,
  reducers: {
    // Add a new dashboard
    addDashboard: (state, action) => ({
      ...state,
      dashboards: [...state.dashboards, action.payload],
    }),
    // Update an existing dashboard by id
    updateDashboard: (state, action) => {
      const { id, data } = action.payload;
      return {
        ...state,
        dashboards: state.dashboards.map((d) => (d.id === id ? { ...d, ...data } : d)),
      };
    },
    // Delete a dashboard by id
    deleteDashboard: (state, action) => ({
      ...state,
      dashboards: state.dashboards.filter((d) => d.id !== action.payload),
    }),
    // Get all dashboards (no-op for Redux, but for API completeness)
    getDashboards: (state) => state,
  },
});

export const { addDashboard, updateDashboard, deleteDashboard, getDashboards } =
  DashboardConfigSlice.actions;
export default DashboardConfigSlice;
